<template>
   <div>
      <div>
         <label>Etunimi</label>
         <input type="text" v-model="caretaker.firstname" />
      </div>

      <div>
         <label>Sukunimi</label>
         <input type="text" v-model="caretaker.lastname" />
      </div>

      <div>
         <label>Sähköpostiosoite</label>
         <input type="email" v-model="caretaker.email" />
      </div>

      <div>
         <label>Puhelinnumero</label>
         <input type="phone" v-model="caretaker.phone" />
      </div>

      <div>
         <button class="btn-copy-address" @click="store.copyChildAddressForCaretaker(caretaker)">Kopioi lapsen osoite huoltajalle</button>
      </div>

      <div>
         <label>Osoite</label>
         <input type="text" v-model="caretaker.address.street" />
      </div>

      <div>
         <label>Postinumero</label>
         <div>
            <input type="text" v-on:input="processZip(caretaker.address.zip)" v-model="caretaker.address.zip" />
         </div>
      </div>

      <div>
         <label>Kaupunki</label>
         <div>
            <input placeholder="Täytetään automaattisesti" type="text" disabled="disabled" v-model="caretaker.address.city" />
         </div>
      </div>
   </div>
</template>

<script>
import zipService from '../services/zipcode.js'

export default {
   props: ['store', 'caretaker'],

   components: {
   },

   data () {
      return {
      }
   },

   methods: {
      processZip (zip) {
         this.caretaker.address.city = zipService.getMunicipality(zip)
      }
   }
}
</script>

<style scoped>
.display-inline {
   display: inline-block;
}

.btn-copy-address {
   @apply border-solid border border-gray-500;
   @apply bg-gray-400 rounded;
   @apply mt-5 p-3;
   @apply w-full;
}

.btn-copy-address:hover,
.btn-copy-address:active,
.btn-copy-address:focus {
   @apply bg-green-500;
   @apply text-white;
   @apply border-green-700;
}

.btn-copy-address:active {
   @apply bg-green-600;
   @apply shadow-inner;
}
</style>
